export default __webpack_public_path__ + "static/media/LAS0150.34I-30436_-17555_0.1bab1d97.jpg";